import type { IconData } from '@stacksjs/iconify-core'

export const folderOpen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M488.671 221.645a23.85 23.85 0 0 0-18.917-9.231h-66.2V160a23.14 23.14 0 0 0-23.112-23.111h-136.3L226.37 94.22A23.05 23.05 0 0 0 205.037 80H39.111A23.14 23.14 0 0 0 16 103.111v364.445h420.707l56.33-225.321a23.85 23.85 0 0 0-4.366-20.59M48 435.556V112h151.111l23.7 56.889h148.745v43.525H137.587a23.965 23.965 0 0 0-23.287 18.179L63.063 435.556Zm363.723 0H96.048l47.785-191.142h315.675Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default folderOpen
